import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { postConfigPtMonAnalogico } from './services'
import { IPostConfigPtMonAnalogico } from './types'

const initialState: any = {
  status: "",
  data: [],
  msgError: ""
}

export const actionPostConfigPtMonAnalogico: any = createAsyncThunk<any, IPostConfigPtMonAnalogico>(
  "ACTION_POST_CONFIG_PT_MON_ANALOGICO",
  async (data, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
            modelo,
          },
          entrada
        }
      },
      equipamentos: {
        dataUnidadeDeMedida
      }
    } = getState()

    return postConfigPtMonAnalogico({
      ...data,
      idLoja: lojaSelected,
      idCentral,
      adrModulo,
      modeloModulo: modelo,
      idEntrada: entrada.id,
      unidadeMedida: dataUnidadeDeMedida.find(({unidade}) => unidade === data.unidadeMedida)?.unidade,
    });
  }
)

const slicePostConfigPtMonAnalogico = createSlice({
  name: "POST_CONFIG",
  initialState,
  reducers: {
    actionResetStateConfigPtMonAnalogico: (state) => {
      state.status = ""
      state.msgError = ""
    }
  },
  extraReducers: {
    [actionPostConfigPtMonAnalogico.pending]: (state) => {
      state.status = "loading"
    },
    [actionPostConfigPtMonAnalogico.fulfilled]: (state) => {
      state.status = "success"
    },
    [actionPostConfigPtMonAnalogico.rejected]: (state, {error: { message }}) => {
      state.status = "error"
      state.msgError = message
    },
  }
})

export default slicePostConfigPtMonAnalogico.reducer
export const { actionResetStateConfigPtMonAnalogico } =
  slicePostConfigPtMonAnalogico.actions;